import { createContext, useReducer } from 'react';
import { IAuthUser } from 'modules/shared/interfaces/auth.interface';
import { AuthService } from 'core/services/auth';

export enum DispatcherAction {
  Login = 'Login',
  Logout = 'Logout',
  ContactSelectDeselect = 'ContactSelectDeselect',
  CampaignSaved = 'CampaignSaved',
}

interface IAppStateData {
  token: string | null;
  user: IAuthUser | null;
  contactIds: Array<string>;
}

type ReducerAction =
  | { type: DispatcherAction.Login; payload: null }
  | { type: DispatcherAction.Logout; payload: null }
  | { type: DispatcherAction.CampaignSaved; payload: null }
  | { type: DispatcherAction.ContactSelectDeselect; payload: string };

const authService = new AuthService();

const initialState: any = {
  token: authService.getAuthToken(),
  user: authService.getAuthUser(),
  contactIds: [],
};

const reducer = (state: IAppStateData, action: ReducerAction) => {
  const { type, payload } = action;
  switch (type) {
    case DispatcherAction.Login:
      const authData = {
        token: authService.getAuthToken(),
        user: authService.getAuthUser(),
      };
      return {
        ...state,
        ...authData,
      };
    case DispatcherAction.Logout:
      return {
        ...state,
        token: null,
        user: null,
      };
    case DispatcherAction.CampaignSaved:
      return {
        ...state,
        contactIds: [],
      };
    case DispatcherAction.ContactSelectDeselect:
      const { contactIds } = state;
      const newContactIds = [...contactIds];
      if (newContactIds.includes(payload)) {
        const index = newContactIds.indexOf(payload);
        newContactIds.splice(index, 1);
      } else {
        newContactIds.push(payload);
      }
      return {
        ...state,
        contactIds: newContactIds,
      };
    default:
      return { ...state };
  }
};

export const AppContext = createContext({ ...initialState });

export const AppContextProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  function dispatcher(type: DispatcherAction, payload: any) {
    dispatch({ type, payload });
  }

  return (
    <AppContext.Provider value={{ state, dispatcher }}>
      {children}
    </AppContext.Provider>
  );
};
